import createIcon from '../../createIcon';

/**
 * @component @name MedicalInformation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgN0gxNVY0QzE1IDIuOSAxNC4xIDIgMTMgMkgxMUM5LjkgMiA5IDIuOSA5IDRWN0g0QzIuOSA3IDIgNy45IDIgOVYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMjBDMjEuMSAyMiAyMiAyMS4xIDIyIDIwVjlDMjIgNy45IDIxLjEgNyAyMCA3Wk0xMSA0SDEzVjlIMTFWNFpNMTEgMTZIOVYxOEg3VjE2SDVWMTRIN1YxMkg5VjE0SDExVjE2Wk0xMyAxNC41VjEzSDE5VjE0LjVIMTNaTTEzIDE3LjVWMTZIMTdWMTcuNUgxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MedicalInformation = createIcon('MedicalInformation', [
  [
    'path',
    {
      d: 'M20 7H15V4C15 2.9 14.1 2 13 2H11C9.9 2 9 2.9 9 4V7H4C2.9 7 2 7.9 2 9V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9C22 7.9 21.1 7 20 7ZM11 4H13V9H11V4ZM11 16H9V18H7V16H5V14H7V12H9V14H11V16ZM13 14.5V13H19V14.5H13ZM13 17.5V16H17V17.5H13Z',
      key: 'oqvuxk',
    },
  ],
]);

export default MedicalInformation;
